<!-- <mat-list class="one-row-list switch-project">
    <mat-list-item class="item" matRipple (click)="switchProject()">
        <div class="title color-white medium-font" mat-line>{{selectedProject?.name}}</div>
        <mat-icon class="color-white">cached</mat-icon>
    </mat-list-item>
</mat-list> -->

<!-- <mat-toolbar class="ifca-general-header"> -->
<!-- <div fxLayout="row wrap" class="line-header" style="display: flex;"> -->

<div class="selected-container" (click)="switchProject()">
  <div class="domain">{{ selectedProject?.company.name }}</div>

  <div class="selected-obj">
    {{ selectedProject?.name }}
  </div>
</div>
<button
  style="width:fit-content; height: fit-content;"
  mat-icon-button
  (click)="switchProject()"
  *ngIf="!disableSwitchProject"
>
  <img class="menu-burger-2" src="assets\images\icon\header-switch-icon.svg"/>
</button>
<!-- </div> -->

<!-- </mat-toolbar> -->
